module.exports = __webpack_public_path__ + "static/spain-6b0e5919dd6f3ac81d2b3dcdafa1d590.jpeg";